import { WaTemplateService } from "@/services";
import { httpClientOmni } from "@/libraries";

const Types = {
  SET_LOADING: "SET_LOADING",
  SET_ERROR: "SET_ERROR",
  SET_TEMPLATE: "SET_ERROR",
};

const state = {
  data: [],
  error: null,
  loading: false,
  template: [],
  isSyncing: false,
  syncTimestamp: null,
};

const getters = {
  loading: (state) => state.loading,
  error: (state) => state.error,
  template: (state) => state.template,
  isSyncing: (state) => state.isSyncing,
  syncTimestamp: (state) => state.syncTimestamp,
};

const mutations = {
  [Types.SET_LOADING]: (state, payload) => (state.loading = payload),
  [Types.SET_ERROR]: (state, payload) => (state.error = payload),
  [Types.SET_TEMPLATE]: (state, payload) => (state.template = payload),
  SET_SYNC_STATE: (state, { isSyncing, syncTimestamp }) => {
    state.isSyncing = isSyncing;
    state.syncTimestamp = syncTimestamp;
  },
  CLEAR_SYNC_STATE: (state) => {
    state.isSyncing = false;
    state.syncTimestamp = null;
  },
};

const actions = {
  startSync: async ({ commit, dispatch }) => {
    try {
      const response = await httpClientOmni.get(
        "sync-hsm-template-for-specific-bsp-and-project"
      );
      commit("SET_SYNC_STATE", { isSyncing: true, syncTimestamp: Date.now() });
      // Check status after 5 minutes
      setTimeout(() => {
        dispatch("checkSyncStatus");
      }, 300000);
      return response;
    } catch (error) {
      commit("CLEAR_SYNC_STATE");
      throw error;
    }
  },
  checkSyncStatus: ({ commit, state }) => {
    if (state.isSyncing) {
      const elapsed = Date.now() - state.syncTimestamp;
      if (elapsed >= 300000) {
        commit("CLEAR_SYNC_STATE");
      }
    }
  },
  async getTemplateByIntegrationId({ commit }, integrationId) {
    // commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.getTemplateByIntegrationId(
        integrationId
      );
      return response;
    } catch (error) {
      console.log("error get template by integration id", error);
      commit(Types.SET_ERROR, error);
    }
    // commit(Types.SET_LOADING, false);
  },
  async v3GetTemplatePaginate({ commit }, payload) {
    // commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.v3GetTemplatePaginate(payload);
      return response;
    } catch (error) {
      console.log("error get template paginate", error);
      commit(Types.SET_ERROR, error);
    }
    // commit(Types.SET_LOADING, false);
  },
  async deleteTemplate({ commit }, id) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.deleteTemplate(id);
      return response;
    } catch (error) {
      console.log("error delete template", error);
      commit(Types.SET_ERROR, error);
      throw error;
    } finally {
      commit(Types.SET_LOADING, false);
    }
  },
  async exportCsv({ commit }, payload) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.exportCsvTemplate(payload);
      return response;
    } catch (error) {
      console.log("error export csv", error);
      commit(Types.SET_ERROR, error);
      throw error;
    } finally {
      commit(Types.SET_LOADING, false);
    }
  },
  async exportPdf({ commit }, payload) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.exportPdfTemplate(payload);
      return response;
    } catch (error) {
      console.log("error export pdf", error);
      commit(Types.SET_ERROR, error);
      throw error;
    } finally {
      commit(Types.SET_LOADING, false);
    }
  },
  async createHsm({ commit }, payload) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.createHsmTemplate(payload);
      return response;
    } catch (error) {
      commit(Types.SET_ERROR, error.response || error);
      throw error;
    } finally {
      commit(Types.SET_LOADING, false);
    }
  },
  async createHsmV4({ commit }, payload) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await WaTemplateService.createHsmTemplateV4(payload);
      return response;
    } catch (error) {
      commit(Types.SET_ERROR, error.response || error);
      throw error;
    } finally {
      commit(Types.SET_LOADING, false);
    }
  },
  async getExternalTemplate({ commit }, payload) {
    try {
      const response = await WaTemplateService.getExternalTemplate(payload);
      return response.data.data;
    } catch (error) {
      commit(Types.SET_ERROR, error);
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
